//#region types
import { StyleEnums } from "models/enums";
import { SalaryDraftTopCardContentProps } from "models/propTypes/salaryPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DateConstants } from "utils/constants";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { EntityTopCardContent } from "components/common";
import { useSalaryService } from "serviceHooks";
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const SalaryDraftTopCardContent: React.FC<SalaryDraftTopCardContentProps> = (props) => {
  const salaryService = useSalaryService();
  const { salaryDraft, statusIndicatorDisplayType } = props;

  const salaryMonth = LocalizationHelperInstance.getFormattedDate(
    DateHelper.getDateFromYearMonth(salaryDraft!.yearAndMonth),
    DateConstants.MonthLongConfig
  );

  const salaryYear = DateHelper.getYear(DateHelper.getDateFromYearMonth(salaryDraft.yearAndMonth)).toString();

  const approvedDate =
    salaryDraft.approvedDate !== undefined ? LocalizationHelperInstance.getFormattedDate(salaryDraft.approvedDate) : "";
  const latestDate = salaryDraft.messages?.length
    ? LocalizationHelperInstance.getFormattedDate(
        salaryDraft.messages.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime())[0]
          .timestamp
      )
    : "";

  const title = LocalizationHelperInstance.getFormattedMessage(
    `Todos.TodoCardName_${WintSuperkollAPIModel.TodoSubType[WintSuperkollAPIModel.TodoSubType.SalaryDraft].toString()}`
  );
  const subTitle = salaryService.getSalaryDraftStateText(salaryDraft.state);

  if (salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.AtCustomer) {
    return (
      <EntityTopCardContent
        title={title}
        subTitle={subTitle}
        descriptionHeadingOne={salaryMonth}
        footerText={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Latest)}: ${latestDate}`}
        statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.Info}
      />
    );
  } else {
    return (
      <EntityTopCardContent
        title={title}
        subTitle={subTitle}
        descriptionHeadingOne={salaryMonth}
        descriptionHeadingTwo={salaryYear}
        footerText={`${LocalizationHelperInstance.getFormattedMessage(
          `Salary.SalaryDraftState_${salaryDraft.state}`
        )}: ${salaryDraft.state === WintSuperkollAPIModel.SalaryDraftState.Approved ? approvedDate : latestDate}`}
        statusIndicatorDisplayType={statusIndicatorDisplayType ?? StyleEnums.DisplayType.None}
      />
    );
  }
};

export default SalaryDraftTopCardContent;
